import { render } from "./PollDialog.vue?vue&type=template&id=8af1fbdc&scoped=true"
import script from "./PollDialog.vue?vue&type=script&lang=js"
export * from "./PollDialog.vue?vue&type=script&lang=js"

import "./PollDialog.vue?vue&type=style&index=0&id=8af1fbdc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af1fbdc"]])

export default __exports__